





























/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Component, Prop, PropSync } from 'vue-property-decorator';
import IntegrityTable, { FillFunctionContainer } from '@/components/IntegrityTable/IntegrityTable.vue';
import { DetailedUserData, ManagedUsersTableData } from '@/store/users/types';
import IntegrityDelete from '@/components/IntegrityDelete/IntegrityDelete.vue';
import { AuthUserRoles, getRoleGuidString } from '@/auth/roles';
import { uuid } from 'vue-uuid';
import AdminPanelMixin, { EditUserData } from '../AdminPanelMixin.vue';

@Component({ components: { IntegrityTable, IntegrityDelete } })
export default class EditUsersManagedUsers extends AdminPanelMixin {
  @Prop({ default: false }) readonly managedUsersLoading: boolean;

  @PropSync('selectedUser') synchedSelectedUser: EditUserData;

  @PropSync('managedUsers') syncedManagedUsers: ManagedUsersTableData[];

  @PropSync('managedUsersForRemoval') syncedManagedUsersForRemoval: ManagedUsersTableData[];

  GetRoleGuidString = getRoleGuidString;

  search = '';

  headers = [
    {
      text: 'User',
      value: 'user',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Email',
      value: 'email',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Role',
      value: 'role',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Organization',
      value: 'organization',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Customer(s)',
      value: 'customers',
      sortable: true,
      filterable: true,
    },
    {
      text: 'Actions',
      value: 'actions',
      sortable: false,
      filterable: false,
    },
  ];

  matchFilters = [
    {
      header: 'user',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'email',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'role',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'organization',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
    {
      header: 'customers',
      type: 'string',
      value: '',
      method: '',
      options: [],
      tempValue: '',
      open: false,
    },
  ];

  get fillTableDataFunctions(): FillFunctionContainer {
    const returnValue: FillFunctionContainer = {
      updateKey: uuid.v4(),
      fillFunctions: [
        {
          headerValue: 'role',
          functionVariables: [AuthUserRoles],
          fillFunction: function fillRoleString(
            item: ManagedUsersTableData,
            authUserRoles: any[],
          ): string {
            const { role } = item;
            if (role == null || role === '') {
              return '';
            }
            const roleObj = authUserRoles.find((r) => r.name === role || r.guid === role);
            return roleObj === undefined ? 'ROLE NOT FOUND' : roleObj.name;
          },
        },
      ],
    };
    return returnValue;
  }

  get tableData() {
    return this.syncedManagedUsers;
  }

  getDeleteText(user: DetailedUserData): string {
    const subjectUserName = this.syncedManagedUsers.find((u) => u.guid === user.guid)?.user;
    const managerUser = this.synchedSelectedUser.detailedUserData;
    const managerUserName = `${managerUser.firstname} ${managerUser.lastname}`;

    return `Are you sure you want to remove ${subjectUserName} as a managed user of ${managerUserName}?`;
  }

  async removeManagedUser(managedUser: ManagedUsersTableData): Promise<boolean> {
    try {
      const deleteIndex = this.syncedManagedUsers
        .findIndex((mu) => mu.userManagementGuid === managedUser.userManagementGuid);

      if (deleteIndex === -1) {
        // If we can not find the item in the syncedManagedUsers
        return false;
      }

      this.syncedManagedUsersForRemoval.push(managedUser);
      this.syncedManagedUsers.splice(deleteIndex, 1);
    } catch (e) {
      return false;
    }

    return true;
  }
}
